import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function LegalModal({
  title,
  content,
  onClose
}: {
  title: string;
  content: React.ReactNode;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-62">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-64">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-[#1B2A4A]" data-id="element-65">
            <h2 className="text-xl font-bold text-white font-serif" data-id="element-66">{title}</h2>
            <button onClick={onClose} className="text-gray-300 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-67">
              <XIcon className="w-6 h-6" data-id="element-68" />
            </button>
          </div>
          <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-69">
            {content}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
const privacyContent = <>
    <p className="text-xs text-gray-500" data-id="element-70">Última actualización: Abril 2026</p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-71">
      1. Información que Recopilamos
    </h3>
    <p data-id="element-72">
      Recopilamos únicamente la información necesaria para procesar tu compra y
      entregar el producto digital, incluyendo tu nombre y dirección de correo
      electrónico.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-73">
      2. Uso de la Información
    </h3>
    <p data-id="element-74">
      Tu información se utiliza exclusivamente para: enviar el producto digital
      adquirido, comunicar actualizaciones importantes del material, y mejorar
      nuestros servicios.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-75">
      3. Protección de Datos
    </h3>
    <p data-id="element-76">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información personal. No almacenamos datos de tarjetas de crédito;
      todos los pagos son procesados por plataformas de pago seguras de
      terceros.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-77">
      4. Compartir Información
    </h3>
    <p data-id="element-78">
      No vendemos, intercambiamos ni transferimos tu información personal a
      terceros. La única excepción son los proveedores de servicios de confianza
      que nos asisten en la operación del sitio web y el procesamiento de pagos.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-79">5. Cookies</h3>
    <p data-id="element-80">
      Nuestro sitio puede utilizar cookies para mejorar la experiencia del
      usuario. Puedes configurar tu navegador para rechazar cookies, aunque esto
      podría afectar algunas funcionalidades.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-81">6. Tus Derechos</h3>
    <p data-id="element-82">
      Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
      personales en cualquier momento.
    </p>
  </>;
const termsContent = <>
    <p className="text-xs text-gray-500" data-id="element-83">Última actualización: Abril 2026</p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-84">
      1. Naturaleza del Producto
    </h3>
    <p data-id="element-85">
      Este es un producto educativo digital. No constituye asesoría legal,
      migratoria ni de inmigración. Para asuntos legales, consulta con un
      abogado de inmigración licenciado.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-86">2. Producto Digital</h3>
    <p data-id="element-87">
      Al completar la compra, recibirás acceso inmediato al material digital
      (PDF + Bundle). Debido a la naturaleza digital del producto, todas las
      ventas son finales.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-88">3. Uso Permitido</h3>
    <p data-id="element-89">
      El material adquirido es para uso personal y exclusivo del comprador.
      Queda prohibida la reproducción, distribución, reventa o compartición del
      contenido sin autorización expresa por escrito.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-90">
      4. Propiedad Intelectual
    </h3>
    <p data-id="element-91">
      Todo el contenido, incluyendo textos, diseños, gráficos y metodologías,
      está protegido por derechos de autor. El Método de Traducción Espejo y
      Anclaje Visual es propiedad exclusiva de Ciudadanía USA: Guía Exprés.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-92">
      5. Limitación de Responsabilidad
    </h3>
    <p data-id="element-93">
      No garantizamos resultados específicos en el examen de ciudadanía. El
      éxito depende del esfuerzo individual del usuario. No nos hacemos
      responsables por decisiones tomadas basándose en este material educativo.
    </p>
    <h3 className="font-bold text-[#1B2A4A] text-base" data-id="element-94">6. Actualizaciones</h3>
    <p data-id="element-95">
      Nos reservamos el derecho de actualizar estos términos en cualquier
      momento. Las actualizaciones serán efectivas al momento de su publicación.
    </p>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="w-full bg-[#1B2A4A] text-white" data-id="element-96">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-97">
          <div className="text-center space-y-4" data-id="element-98">
            <p className="text-sm text-gray-300" data-id="element-99">
              Este es material educativo. No constituye asesoría legal.
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-100">
              <button onClick={() => setActiveModal('privacy')} className="text-sm text-[#C9A84C] hover:text-[#d4b35c] transition-colors underline underline-offset-2" data-id="element-101">
                Política de Privacidad
              </button>
              <span className="text-gray-600" data-id="element-102">|</span>
              <button onClick={() => setActiveModal('terms')} className="text-sm text-[#C9A84C] hover:text-[#d4b35c] transition-colors underline underline-offset-2" data-id="element-103">
                Términos y Condiciones
              </button>
            </div>
            <p className="text-sm text-gray-400" data-id="element-104">
              © 2026 Ciudadanía USA: Guía Exprés. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>

      {activeModal === 'privacy' && <LegalModal title="Política de Privacidad" content={privacyContent} onClose={() => setActiveModal(null)} data-id="element-105" />}
      {activeModal === 'terms' && <LegalModal title="Términos y Condiciones" content={termsContent} onClose={() => setActiveModal(null)} data-id="element-106" />}
    </>;
}